import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import PortalLayout from "../../layouts/PortalLayout.vue";
import ProductLayout from "../../layouts/ProductLayout.vue";
import AdminLayout from "../../layouts/AdminLayout.vue";
import Cards from "../../views/Cards.vue";
import store from "../store";

Vue.use(VueRouter);

const adminRoutes: Array<RouteConfig> = [
  {
    path: "users/",
    component: () => import("../../views/admin/Users.vue"),
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "users/:email/",
    component: () => import("../../views/admin/User.vue"),
    // http://jsfiddle.net/L7hscd8h/9377/
    pathToRegexpOptions: { strict: true },

    children: [
      {
        path: "/",
        redirect: "general"
      },
      {
        path: "general",
        component: () => import("../../views/admin/UserGeneral.vue")
      },
      {
        path: "products",
        component: () => import("../../views/admin/UserProducts.vue")
      },
      {
        path: "cognito",
        component: () => import("../../views/admin/UserCognito.vue")
      },
      {
        path: "post",
        component: () => import("../../views/admin/UserPost.vue")
      },
      {
        path: "topicPulse",
        component: () => import("../../views/admin/UserTopicPulse.vue")
      },
      {
        path: "topLine",
        component: () => import("../../views/admin/UserTopLine.vue")
      },
      {
        path: "tether",
        component: () => import("../../views/admin/UserTether.vue")
      }
    ]
  }
];

const children: Array<RouteConfig> = [
  {
    path: "/products/:productType/",
    props: true,
    component: ProductLayout,

    beforeEnter(_to, _from, next) {
      store.dispatch("fetchPortalData").then(() => next());
    },

    children: [
      {
        path: "/",
        props: true,
        component: Cards

        // beforeEnter(_to, _from, next) {
        //   console.log('enter products home')
        //   store.dispatch('fetchPortalData').then(() => next())
        // },
      }
    ]
  },
  {
    path: "/admin",
    pathToRegexpOptions: { strict: true },
    component: AdminLayout,
    children: adminRoutes
  },
  {
    path: "/about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../../views/About.vue")
  }
];

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: PortalLayout,
    children,

    async beforeEnter(_to, _from, next) {
      await store.dispatch("fetchPortalData");
      await store.dispatch("admin/fetchAdminUsers");
      next();
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
